import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Pill } from "@aviary";
import { useSharedGlobalConfig } from "@shared/hooks";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreOffersPill.styles";
interface Props {
  patientAttributes: PatientAttributes;
}

const StoreOffersPill: FC<Props> = ({ patientAttributes }) => {
  const { t } = useTranslation();
  const { isUS } = useSharedGlobalConfig();
  const { discount } = patientAttributes;

  const renderFreeShipping = () =>
    !isUS ? t(l.patientRxAuth.FreeShippingCA) : t(l.patientRxAuth.FreeShippingUS);

  return (
    <div css={styles.pillContainer}>
      {!!discount && (
        <Pill isColor="primary" css={styles.pill}>
          {t(l.patientRxAuth.Discount, { discount })}
        </Pill>
      )}
      <Pill isColor="primary" css={styles.pill}>
        {renderFreeShipping()}
      </Pill>
    </div>
  );
};

export { StoreOffersPill };
